module.exports = __webpack_public_path__ + "img/combined-shape.65a86901.svg";